export const VALIDATE_VOUCHER = /* GraphQL */ `
  mutation ValidateVoucher($voucher: String!, $program: String) {
    validateVoucher(voucher: $voucher, program: $program) {
      valid
    }
  }
`;
